import styled from "styled-components";

export const ErrorContainer = styled.div`
    height:100vh;
`